import React, { useState } from 'react'
import List from '../../../../../components/Operations/Transport/Management/FuelLines/List'
import { message } from 'antd'
import FuelLines from '../../../../../api/Sales/FuelLines'
import useFetchList from '../../../../../elements/Hooks/useFetchList'
import useSelectionTable from '../../../../../elements/Hooks/useSelectionTable'

const api = new FuelLines()

function FuelLinesCont () {
  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()
  const [billLines, setBillLines] = useState([])
  const [visibleInvoice, setVisibleInvoice] = useState(false)
  const { list: fuelLines, fetch, fetching } = useFetchList(api.list)
  const invoiceFuelLines = async () => {
    const newSelection = selection.map(t => fuelLines.find(i => i._id === t))
    if (newSelection.find(s => s.processed.state === true)) {
      message.error(`Can't invoice processed fuel lines`)
      return
    }
    setVisibleInvoice(true)
    setBillLines(newSelection.map(s => s))
  }
  const onCancelInvoice = () => {
    setVisibleInvoice(false)
    setSelection([])
    fetch()
  }
  return (
    <List
      {...{
        fuelLines,
        selection,
        fetching,
        billLines,
        selectAll,
        visibleInvoice,
        //not state
        fetch,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
        invoiceFuelLines,
        onCancelInvoice,
      }}
    />
  )
}

FuelLinesCont.propTypes = {}
FuelLinesCont.defaultProps = {}

export default (FuelLinesCont)
